<template>
  <div id="app">
    <router-view />
    <!-- Tasto Indietro globale su ogni pagina kiosk (tranne la home). -->
    <KioskBackButton v-if="isKiosk" />
    <!-- Ritorno automatico alla home dopo 120s di inattività (tranne home). -->
    <KioskIdleTimeout v-if="isKiosk" />
    <!-- Checkout: «Chiudi» in alto a destra con il conto alla rovescia, nome del socio al centro. -->
    <KioskCheckoutBar v-if="isKiosk" />
    <!-- Pagamento con carta sul POS: cosa fare mentre il terminale aspetta il socio. -->
    <KioskCardOverlay v-if="isKiosk" />
    <!-- Overlay globale con timer di inserimento contanti (solo kiosk). -->
    <KioskPaymentOverlay v-if="isKiosk" />
    <!-- Gesture nascosta (6 tap in alto a destra) + PIN per la manutenzione. -->
    <KioskAdminGate v-if="isKiosk" />
  </div>
</template>

<script>
import { IS_KIOSK } from '@/config/kiosk'
import KioskPaymentOverlay from '@/components/KioskPaymentOverlay.vue'
import KioskBackButton from '@/components/KioskBackButton.vue'
import KioskIdleTimeout from '@/components/KioskIdleTimeout.vue'
import KioskAdminGate from '@/components/KioskAdminGate.vue'
import KioskCheckoutBar from '@/components/KioskCheckoutBar.vue'
import KioskCardOverlay from '@/components/KioskCardOverlay.vue'

export default {
  name: 'App',
  components: { KioskPaymentOverlay, KioskBackButton, KioskIdleTimeout, KioskAdminGate, KioskCheckoutBar, KioskCardOverlay },
  data() {
    return { isKiosk: IS_KIOSK }
  },
  mounted() {
    document.title = 'Elite Fitness'
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || 'Elite Fitness'
    }
  }
};
</script>

<style>
body{
  background-color: #292D7D;
}
</style>
